import { defineComponent } from 'vue';
import eventBus from '@/services/EventBus';
export default defineComponent({
    mounted() {
        this.$nextTick(() => {
            eventBus.emit('PageReady');
        });
    },
});
